import { render } from "./CreatestocklistView.vue?vue&type=template&id=00041bdf"
import script from "./CreatestocklistView.vue?vue&type=script&lang=js"
export * from "./CreatestocklistView.vue?vue&type=script&lang=js"

import "./CreatestocklistView.vue?vue&type=style&index=0&id=00041bdf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__